import { render } from "./CommonArticle.vue?vue&type=template&id=7600ae1b"
import script from "./CommonArticle.vue?vue&type=script&lang=js"
export * from "./CommonArticle.vue?vue&type=script&lang=js"

import "./CommonArticle.vue?vue&type=style&index=0&id=7600ae1b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__